import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import { DropdownButtonItem } from 'components/buttons/BzDropdownButton';
import Button from 'react-bootstrap/Button';
import { transactionMatchersDropdownOperators } from 'views/AssetCatalog/Transactions/TransactionEditor/TransactionEditor';
import { useTranslation } from 'react-i18next';
import BzmIcon from '../icons/BzmIcon';
import MatcherOperatorDropdown from './MatcherOperatorDropdown';
import { Matcher, MatcherDsl } from '../../types/rest/dslTypes';
import { conditionalMatchers } from '../../constants/ui-constants';
import _ from 'lodash';

interface ConditionMatcherProps {
  id: string;
  matcherValues: MatcherDsl;
  onChange: (name: string, value: string) => void;
  onDelete: () => void;
  /** On Add New element */
  onAdd: () => void;
  showAddIcon: boolean;
  displayAdd: boolean;
  matcherTitle: string;
  isReadOnly?: boolean;
  isWizardModal?: boolean;
  shortTitle?: boolean;
  colSizes: { md: ('auto' | number)[] };
}

const ConditionMatcher = (props: ConditionMatcherProps) => {
  const { t } = useTranslation('transactions');

  const defaultOperator: DropdownButtonItem = {
    key: Matcher.equals,
    title: transactionMatchersDropdownOperators[Matcher.equals],
  };

  const operatorToSelect: DropdownButtonItem =
    props.matcherValues && props.matcherValues.matcherName
      ? {
          key: props.matcherValues.matcherName,
          title: props.matcherValues.matcherName,
        }
      : defaultOperator;

  const handleChange = (e: any) => {
    const target = e.target as HTMLInputElement;
    props.onChange(target.name, target.value);
  };

  const isAbsent = _.get(props.matcherValues, 'matcherName', false) === 'absent';
  if (props.isWizardModal === true && props.matcherValues.matcherName !== 'equals') {
    props.onChange('matcherName', 'equals');
  }

  const { colSizes, isReadOnly } = props;

  return (
    <>
      <Row className={'mb-2'}>
        <Col md={colSizes.md[0]} className={'text-center'}>
          <strong className={'position-relative'} style={{ top: '5px' }}>
            If
          </strong>
        </Col>
        <Col md={colSizes.md[1]}>
          <Form.Control
            disabled={isReadOnly}
            name="key"
            as="input"
            autoComplete={'off'}
            onChange={handleChange}
            placeholder={t('conditionalStatusCodes.expressionPlaceholder')}
            value={props.matcherValues.key ? props.matcherValues.key : ''}
          />
        </Col>
        <Col md={colSizes.md[2]}>
          <MatcherOperatorDropdown
            isReadOnly={isReadOnly}
            selected={operatorToSelect}
            operators={conditionalMatchers}
            onSelect={(item: DropdownButtonItem) => props.onChange('matcherName', item.key)}
            id={'op-' + props.id}
            isShortTitle={props.shortTitle}
          />
        </Col>
        <Col md={colSizes.md[3]}>
          <Form.Control
            placeholder={t('conditionalStatusCodes.valuePlaceholder')}
            name={'matchingValue'}
            autoComplete={'off'}
            onChange={handleChange}
            value={isAbsent ? '' : props.matcherValues.matchingValue ? props.matcherValues.matchingValue : ''}
            disabled={isAbsent || isReadOnly}
          />
        </Col>
        <Col md={colSizes.md[4]}>
          <Button
            variant="danger"
            id={'qa-btn-delete-matcher-' + props.id}
            onClick={props.onDelete}
            className="btn-circular"
            title={t('editor.deleteMatcher', { name: props.matcherTitle })}
          >
            <BzmIcon variant={'icon-bzm-delete'} />
          </Button>

          {props.showAddIcon && (
            <Button
              variant="outline-primary"
              id={'qa-btn-add-new-matcher-' + props.id}
              onClick={props.onAdd}
              className="btn-circular ml-2"
              title={'Add New Matcher'}
            >
              <BzmIcon variant={'icon-bzm-add'} />
            </Button>
          )}
        </Col>
      </Row>
    </>
  );
};

export default ConditionMatcher;
